let store;

export const setStore = (_store) => store = _store;

export const getStore = () => store;

export const getState = () => store.getState();

export const dispatch = (...args) => store.dispatch(...args);